import React, { useState, useEffect } from 'react'
import { PropTypes } from 'prop-types'
import * as Tooltip from '@radix-ui/react-tooltip';
import LinkIcon from 'images/icons/link-icon.inline.svg'
import { WEBSITE_URL } from 'config/index';
import { permaBtn, linkIcon, toolTipContent, toolTipArrow, copy } from './permacopy-styles.module.scss'

function PermalinkCopy({
    path
}){

    const [isClicked, setIsClicked ] = useState(false)

    useEffect(() => {
        const copiedTimer = setTimeout(() => {
            if(isClicked){
                setIsClicked(false)
            }
        }, 3000)
        return () => clearTimeout(copiedTimer)
    }, [isClicked])

    return (
        <Tooltip.Provider>
            <Tooltip.Root open={isClicked} onOpenChange={()=>{}}>
            <Tooltip.Trigger asChild >
                <button type='button' onClick={() => {
                  navigator.clipboard.writeText(`${WEBSITE_URL}${path}`)
                  setIsClicked(true)
                }} className={permaBtn}>
                    <span style={{color: 'var(--color-text-3)'}}> Permalink</span> <LinkIcon className={linkIcon}/> 
                </button>
            </Tooltip.Trigger>
            <Tooltip.Portal>
                <Tooltip.Content className={toolTipContent} sideOffset={5} side="bottom">
                    <span className={copy}>Copied!</span>
                <Tooltip.Arrow className={toolTipArrow} />
                </Tooltip.Content>
            </Tooltip.Portal>
            </Tooltip.Root>
        </Tooltip.Provider>
    )
}


PermalinkCopy.propTypes = {
    path: PropTypes.string.isRequired
}


export default PermalinkCopy